import React, { Component } from "react";
import Skeleton from "react-loading-skeleton";
import _ from "lodash";
import { Modal, Button } from "react-bootstrap";
import DetailItem from "../../components/detailItem";
import textFormatService from "../../services/utility/textFormatService";

interface IInstitutionAppzoneFeePaymentReportDetailProps {
  showDetailsModal: boolean;
  toggleDetailsModal: any;
  item: any;
}

interface IInstitutionAppzoneFeePaymentReportDetailState {
}

class AppzoneFeePaymentReportDetail extends Component<
  IInstitutionAppzoneFeePaymentReportDetailProps,
  IInstitutionAppzoneFeePaymentReportDetailState
> {
  constructor(props: IInstitutionAppzoneFeePaymentReportDetailProps) {
    super(props);
    this.state = {
    };
  }

  render() {
    const { showDetailsModal, toggleDetailsModal, item } = this.props;
    return (
      <Modal
        size="xl"
        backdrop="static"
        show={showDetailsModal}
        onHide={toggleDetailsModal}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {_.isEmpty(item) ? (
              <Skeleton width={500} />
            ) : (
              <h5>
                <i className="fas fa-receipt fa-sm s-18 mr-3" />
                Appzone Fee Payment Details
              </h5>
            )}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="card">
            <div className="card-header clear-fix">
              {_.isEmpty(item) ? (
                <Skeleton width={200} />
              ) : (
                <h6
                  className="card-title float-left"
                  style={{ marginBottom: "0px" }}
                >
                  <b>General Information</b>
                </h6>
              )}
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-6">
                  {_.isEmpty(item) ? (
                    <Skeleton count={8} width={300} />
                  ) : (
                    <dl className="row">
                      <DetailItem
                        label="Service Offering"
                        value={item.serviceOffering}
                      />
                      <DetailItem
                        label="Transaction Volume"
                        value={item.transactionVolume}
                      />
                      <DetailItem
                        label="Amount Payable"
                        value={textFormatService.formatCurrency(item.amountPayable, 2)}
                      />
                      <DetailItem
                        label="Amount Paid"
                        value={textFormatService.formatCurrency(item.amountPaid, 2)}
                      />
                    </dl>
                  )}
                </div>
                <div className="col-md-6">
                  {_.isEmpty(item) ? (
                    <Skeleton count={8} width={300} />
                  ) : (
                    <dl className="row">
                      <DetailItem
                        label="Institution Code"
                        value={item.institutionCode}
                      />
                      <DetailItem
                        label="Transaction Reference"
                        value={item.reference}
                      />
                      <DetailItem
                        label="Date Created"
                        value={textFormatService.formatTimeString(item.dateCreated)}
                      />
                      <DetailItem
                        label="Status"
                        value={
                          (item ? item.status : "Successful") === "Successful" ? (
                            <span className="badge badge-success">
                              {item ? item.status : ""}
                            </span>
                          ) : (
                            <span className="badge badge-danger">
                              {item ? item.status : ""}
                            </span>
                          )
                        }
                      />
                      {item.status == "Failed" ? (
                        <DetailItem
                          label="Response Message"
                          value={item.responseMessage}
                        />
                      ) : ""}
                    </dl>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            size="sm"
            variant="outline-danger"
            onClick={toggleDetailsModal}
          >
            <i className="fas fa-times mr-3" />
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default AppzoneFeePaymentReportDetail;
